export default __webpack_public_path__ + "static/media/dellcertificate.abea0fbe.jpg";